export default __webpack_public_path__ + "static/media/heart.277f826b.png";